import React from 'react';

const MultiTypeComponent = ({ text, logic }) => {
  return <>{logic(text)}</>;
};

export default MultiTypeComponent;
